module.exports = __webpack_public_path__ + "img/76071.bcd503d0.svg";